<ng-scrollbar externalViewport appearance="compact" visibility="hover" [ngClass]="{ 'w-full': true }">
  <div scrollViewport [ngClass]="{ 'w-full ': true }" [ngStyle]="{ height: 'calc(100vh - 66px)' }">
    <div class="flex flex-col justify-between h-[90vh] gap-10 p-2">
      <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed" nzTheme="light" class="flex-1">
        @for (nav of menuList(); track $index) { @if (nav.subMenuList &&
        nav.subMenuList.length > 0) {
        <li nz-submenu [nzTitle]="titleTemplate" nz-tooltip nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? nav.name : ''">
          <ng-template #titleTemplate>
            <a class="flex gap-3 items-center min-w-[40px] min-h-[40px]">
              <svg-icon [src]="nav.icon"></svg-icon>
              <span>{{ nav.name }}</span>
            </a>
          </ng-template>

          <ul>
            @for(item of nav.subMenuList; track $index) {
            <li nz-menu-item [nzMatchRouterExact]="item.exact" nzMatchRouter>
              <a [routerLink]="item.link" [queryParams]="item.queryParams"
                class="flex gap-3 items-center min-w-[40px] min-h-[40px]">
                <svg-icon [src]="item.icon"></svg-icon>
                <!-- <span class="text-2xl">.</span> -->
                <span>{{ item.name }}</span>
              </a>
            </li>
            }
          </ul>
        </li>
        } @else {
        <li nz-menu-item [nzDanger]="nav.type === 'Danger'" [nzMatchRouterExact]="nav.exact" nzMatchRouter nz-tooltip
          nzTooltipPlacement="right" [nzTooltipTitle]="isCollapsed ? nav.name : ''">
          <a [routerLink]="nav.link" [queryParams]="nav.queryParams"
            class="flex gap-3 items-center min-w-[40px] min-h-[40px]">
            <svg-icon [src]="nav.icon" [svgStyle]="{ 'width.px': 24 }"></svg-icon>
            <span>{{ nav.name }}</span>
          </a>
        </li>
        } }
      </ul>

      <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed" nzTheme="light">
        @for (nav of menuList2(); track $index) {
        <li nz-menu-item [nzDanger]="nav.type === 'Danger'" [nzMatchRouterExact]="nav.exact" nzMatchRouter nz-tooltip
          nzTooltipPlacement="right" [nzTooltipTitle]="isCollapsed ? nav.name : ''" [ngClass]="{
            '!mt-auto':
              menuList().length - 1 === $index && nav.type === 'Danger'
          }">
          <a [routerLink]="nav.link" [queryParams]="nav.queryParams"
            class="flex gap-3 items-center min-w-[40px] min-h-[40px]">
            <svg-icon [src]="nav.icon" [svgStyle]="{ 'width.px': 24 }"></svg-icon>
            <span>{{ nav.name }}</span>
          </a>
        </li>
        }
      </ul>
    </div>
  </div>
</ng-scrollbar>